import { camelCase } from "lodash";

const requireModule = require.context(".", false, /\.js$/);
const requireOuterModule = require.context(
  "../../modules/",
  true,
  /store\.js$/
);
const modules = {};

requireModule.keys().forEach(fileName => {
  if (fileName === "./index.js") return;

  const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, ""));

  modules[moduleName] = requireModule(fileName).default;
});

// Require stores defined in modules
requireOuterModule.keys().forEach(fileName => {
  const moduleName = camelCase(fileName.replace(/(\.\/|store\.js)/g, ""));

  modules[moduleName] = requireOuterModule(fileName).default || {};
});

console.log("modules", Object.keys(modules));

export default modules;
